// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_Lbd","cls2":"ClaimEvaluationRow-cls2_7Uv ClaimEvaluationRow-cls1_Lbd"};